import { render, staticRenderFns } from "./RemoveOrArchivePatient.vue?vue&type=template&id=5cf2c1f5&"
import script from "./RemoveOrArchivePatient.vue?vue&type=script&lang=js&"
export * from "./RemoveOrArchivePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports